import { render, staticRenderFns } from "./Appartment.vue?vue&type=template&id=8624a83c&scoped=true&"
import script from "./Appartment.vue?vue&type=script&lang=ts&"
export * from "./Appartment.vue?vue&type=script&lang=ts&"
import style0 from "./Appartment.vue?vue&type=style&index=0&id=8624a83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8624a83c",
  null
  
)

export default component.exports